
import { Profile } from '@/types/auth';

const PROFILE_CACHE_KEY = 'auth_profile_cache';

interface CachedProfile {
  profile: Profile;
  timestamp?: number;
}

// Return the profile from cache if it exists, ignore expiration
export const getCachedProfile = (userId: string): Profile | null => {
  try {
    const cached = localStorage.getItem(`${PROFILE_CACHE_KEY}_${userId}`);
    if (!cached) return null;

    const { profile }: CachedProfile = JSON.parse(cached);

    console.log('Using cached profile (no expiration)', { userId, username: profile.username });
    return profile;
  } catch (error) {
    console.error('Error reading cached profile:', error);
    return null;
  }
};

export const setCachedProfile = (userId: string, profile: Profile) => {
  try {
    const cache: CachedProfile = {
      profile,
      timestamp: Date.now(), // Kept for compatibility, but not used anymore
    };
    localStorage.setItem(`${PROFILE_CACHE_KEY}_${userId}`, JSON.stringify(cache));
    console.log('Profile cached successfully (no expiration)', { userId, username: profile.username });
  } catch (error) {
    console.error('Error caching profile:', error);
  }
};

export const clearCachedProfile = (userId: string) => {
  localStorage.removeItem(`${PROFILE_CACHE_KEY}_${userId}`);
  console.log('Profile cache cleared', { userId });
};
